import { useMemo } from "react";
import { MainService } from "../../interfaces/MainService";
import { Project } from "../../interfaces/project";

export const useProjectsForMainService = (): Record<MainService, Project[]> =>
  useMemo(
    () => ({
      [MainService.ItConsulting]: [
        Project.Bnbhotels,
        Project.Medihead,
        Project.Resolvio,
      ],
      [MainService.SoftwareDevelopment]: [
        Project.Medihead,
        Project.Resolvio,
        Project.Picwise,
        Project.BouldernPfalz,
      ],
      [MainService.Websites]: [
        Project.Vitis,
        Project.Bnbhotels,
        Project.Rheinelement,
        Project.EvolvingRegions,
        Project.Ksv,
      ],
    }),
    []
  );
